import { gql } from '@apollo/client';

// NOTE: NotificationQueryInput type doesn't exist in backend schema
// The notifications query only accepts first/after for pagination
export const NOTIFICATIONS_QUERY = gql`
  query Notifications($first: Int, $after: String) {
    notifications(first: $first, after: $after) {
      edges {
        node {
          _id
          message
          read
          createdAt
          type
          data
        }
      }
    }
  }
`;

export const MARK_NOTIFICATION_READ = gql`
  mutation MarkNotificationRead($id: String!) {
    markNotificationRead(_id: $id)
  }
`;
